module.exports = __webpack_public_path__ + "img/paint.5beafb6c.png";